import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './FactBlock.module.scss';
import classNames from 'classnames';
import FactOrFictionButtons from './FactOrFictionButtons';
import FactButton from './FactButton';
import flipAnimator from './flipAnimator';
import {videoURL} from './mediaBundle';

export default class FactBlock extends Component {
    static propTypes = {
        game: PropTypes.object.isRequired,
        onUpdateUserChoice: PropTypes.func.isRequired,
    };

    state = {
        maxVideoHeight: 9999,
    };

    flipAnimators = [];

    updateVideoHeightPromiseResolve = null;
    updateVideoHeightPromise = new Promise(
        resolve => (this.updateVideoHeightPromiseResolve = resolve)
    );

    timers = [];

    addTimeout(fn, delay) {
        this.timers.push(setTimeout(fn, delay));
    }

    componentDidMount() {
        for (const refName of ['header', 'video', 'rightFact']) {
            const element = ReactDOM.findDOMNode(this.refs[refName]);
            this.flipAnimators.push(
                flipAnimator(element, styles.flipTransition, {
                    delay: 0,
                    ratio: refName === 'video' ? 16 / 9 : null,
                })
            );
        }

        this.updateMaxVideoHeight();
    }

    componentWillUpdate(nextProps) {
        if (
            this.isUserRightFactSelectionFinished(nextProps) !==
            this.isUserRightFactSelectionFinished(this.props)
        ) {
            for (const flipAnimator of this.flipAnimators) {
                flipAnimator.animateFrom();
            }
        }
    }

    doAnimateOnNextDidUpdate = false;

    // TODO(dmitry): refactor this
    componentDidUpdate(prevProps) {
        if (
            this.isUserRightFactSelected(prevProps) !==
            this.isUserRightFactSelected(this.props)
        ) {
            this.addTimeout(() => {
                this.props.onUpdateUserChoice({
                    rightFactSelected: true,
                });
            }, 2000);
            return;
        }

        if (this.doAnimateOnNextDidUpdate) {
            this.doAnimateOnNextDidUpdate = false;
            this.doFlipAnimate();
        }

        const needWaitNextRender = this.updateMaxVideoHeight();

        if (
            this.isUserRightFactSelectionFinished(prevProps) !==
            this.isUserRightFactSelectionFinished(this.props)
        ) {
            if (needWaitNextRender) {
                this.doAnimateOnNextDidUpdate = true;
            } else {
                this.doFlipAnimate();
            }
        }
    }

    updateMaxVideoHeight() {
        const {width, height} = this.refs.video.getBoundingClientRect();
        if (height > (9 / 16) * width) {
            const nextMaxVideoHeight = (9 / 16) * width;
            if (this.state.maxVideoHeight > nextMaxVideoHeight) {
                this.setState({maxVideoHeight: nextMaxVideoHeight});
                return true;
            }
        }

        return false;
    }

    doFlipAnimate() {
        for (const flipAnimator of this.flipAnimators) {
            flipAnimator.animateTo();
        }
    }

    componentWillUnmount() {
        for (const flipAnimator of this.flipAnimators) {
            flipAnimator.stop();
        }
        this.timers.forEach(clearTimeout);
    }

    render() {
        const {maxVideoHeight} = this.state;
        const {game, onUpdateUserChoice} = this.props;
        const {scenario, userChoice} = game;

        const userRightFactSelected = this.isUserRightFactSelected(this.props);
        const userRightFactSelectionFinished = this.isUserRightFactSelectionFinished(
            this.props
        );
        const rightAnswerFactButtonLabel = scenario.fact ? 'Fact!' : 'Fiction!';

        const factBlockClassName = classNames(styles.factBlock, {
            [styles.factBlockAnswered]: userRightFactSelectionFinished,
        });

        const rightAnswerFactClassName = classNames(styles.rightAnswerFactButton, {
            [styles.rightAnswerFactButtonVisible]: userRightFactSelected,
        });

        return (
            <div className={factBlockClassName}>
                <div className={styles.fakeFullWidth} />

                <header ref='header' className={styles.header}>
                    {scenario.question}
                </header>

                <div
                    className={styles.videoContainer}
                    style={{maxHeight: maxVideoHeight}}
                >
                    <div ref='video' className={styles.videoWrapper}>
                        <video
                            className={styles.video}
                            src={videoURL(scenario.video)}
                            muted
                            autoPlay
                            loop
                        />
                    </div>

                    <div className={styles.rightAnswerFactButtonAnchor}>
                        <div
                            ref='rightFact'
                            className={styles.rightAnswerFactButtonWrapper}
                        >
                            <FactButton
                                label={rightAnswerFactButtonLabel}
                                disabled
                                className={rightAnswerFactClassName}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.factFictionButtonsAnimationWrapper}>
                    <FactOrFictionButtons
                        scenario={scenario}
                        userChoice={userChoice}
                        disabled={userRightFactSelected}
                        onUpdateUserChoice={onUpdateUserChoice}
                    />
                </div>
            </div>
        );
    }

    isUserRightFactSelectionFinished(props) {
        const {game} = props;
        const {userChoice} = game;

        return userChoice.rightFactSelected;
    }

    isUserRightFactSelected(props) {
        const {game} = props;
        const {scenario, userChoice} = game;

        return Boolean(userChoice.factSelected && userChoice.fact === scenario.fact);
    }
}
